import type { Connection, MedicalTreatmentPlan } from "@/lib/types";
import { getActiveContactConnections } from "./item-contact-connections";

const PLAN_FULFILLER_CONNECTION_TYPES = [
  "matter_medical_treatment_plan_to_fulfiller",
  "matter_medical_treatment_plan_to_legacy_fulfiller",
] as const;

export const getPlanFulfillerConnections = (
  plan: MedicalTreatmentPlan | undefined,
): Connection[] =>
  PLAN_FULFILLER_CONNECTION_TYPES.flatMap((connectionType) =>
    getActiveContactConnections(
      plan,
      "matter_medical_treatment_plan",
      connectionType,
    ),
  );

export const getPlanFulfillerConnection = (plan?: MedicalTreatmentPlan) =>
  getPlanFulfillerConnections(plan)[0] as Connection | undefined;

export const PLAN_FULFILLER_CONNECTION_TYPE =
  "matter_medical_treatment_plan_to_fulfiller";
